import { TMappedAnswersState } from '../types';

interface IParams {
  mappedAnswersState: TMappedAnswersState;
  // oxlint-disable-next-line typescript/no-explicit-any
  error: any;
}

const excludedFieldKeys: Array<keyof TMappedAnswersState> = ['fullName', 'email', 'phone'];

/**
 * Утилита подготавливает набор лог-данных, исключая из ответов юзера персональные данные
 * */
export const prepareErrorMeta = ({ mappedAnswersState, error }: IParams) => {
  const meta = {
    ...mappedAnswersState,
    error,
  };

  excludedFieldKeys.forEach(key => {
    delete meta[key];
  });

  return meta;
};
